import { CommonModule, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmationdialogcomponent',
  imports: [NgIf,CommonModule],
  templateUrl: './confirmationdialogcomponent.component.html',
  styleUrl: './confirmationdialogcomponent.component.css'
})
export class ConfirmationdialogcomponentComponent {

  is_open = false;
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() confirmText: string = 'Yes';
  @Input() cancelText: string = 'No';
  @Output() confirmed = new EventEmitter();

  open() {
    this.is_open = true;
  }

  close() {
    this.is_open = false;
  }

  confirm() {
    this.confirmed.emit();
    this.close();
  }
}
